import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import MoxeyX from "../static/icons/moxey-x.png";
import MenuIcon from "../static/icons/menu-burger.png";

import { OnlyInMobile } from "../components/Responsive";
import { Sidebar } from "./AppSidebar";
import AppDateRange from "../components/AppDateRange";
import AppProgramSelect from "../components/AppProgramSelect";
import { ROUTES } from "../routes";
import { APP_ROLES } from "../consts/AppRoles";
import { useSidebarRoutes } from "../hooks/useSidebarRoutes";
import LocaleSwitch from "../components/LocaleSwitch";
// import { AppRegionSelect } from "./AppRegionSelect";

export const AppNavbar = () => {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const { FooterMenu, PrimaryMenu } = useSidebarRoutes();

  return (
    <>
      <div className="app-navbar">
        <Link
          to={ROUTES.PROFILE}
          className=" text-secondary text-decoration-none me-auto d-none d-sm-none d-md-block d-lg-block"
        >
          <h6 className="m-0 p-0">
            {currentUser
              ? `${currentUser.firstName} ${currentUser.lastName}`
              : "Client Name"}
            {" - "}
            <span>{APP_ROLES[currentUser?.productType]}</span>
          </h6>
        </Link>

        <Link
          to={ROUTES.PROFILE}
          className="fw-bold text-secondary text-decoration-none me-auto d-block d-sm-block d-md-none d-lg-none"
        >
          <img
            draggable="false"
            src={MoxeyX}
            alt="moxey-logo"
            style={{ width: "20px", height: "20px" }}
          />
        </Link>

        {/* Select date range for pages */}
        <AppDateRange />

        {/* switch from availble regions */}
        {/* <AppRegionSelect /> */}

        {/* Select Program for the current user based on country*/}
        <AppProgramSelect />

        <LocaleSwitch />

        <OnlyInMobile>
          <a
            className="btn p-0 ms-3"
            data-bs-toggle="offcanvas"
            href="#mobileSidebar"
            role="button"
            aria-controls="mobileSidebar"
          >
            <img
              draggable="false"
              src={MenuIcon}
              className="img-fluid"
              style={{ width: "20px" }}
              alt="moxey-logo"
            />
          </a>
        </OnlyInMobile>
      </div>

      {/* sidebar on mobile screen */}
      <OnlyInMobile>
        <div
          style={{ width: "250px" }}
          className="offcanvas offcanvas-start"
          tabIndex="-1"
          id="mobileSidebar"
          aria-labelledby="mobileSidebarLabel"
        >
          <div className="offcanvas-body p-0">
            <Sidebar FooterMenu={FooterMenu} PrimaryMenu={PrimaryMenu} />
          </div>
        </div>
      </OnlyInMobile>
    </>
  );
};
